import React from "react";

const styles = {
  opt: {
    padding: "10px",
    width: "100%",
    borderRadius: "10px",
  },
  que: {
    marginBottom: "5px",
    padding: "20px",
  },
  ansText: {
    marginLeft: "10px",
  },
  pointer: {
    cursor: "pointer",
  },
  selectedOpt: {
    background: "#ffa500d6",
    fontWeight: "bold",
  },
  bb: {
    borderBottom: "1px solid #e9e9e9",
  },
};
export default ({ data, isLast, value, form, setAllRequired }) => {
  const classes = styles;

  return (
    <div
      key={data.id}
      style={Object.assign({}, classes.que, isLast ? {} : classes.bb)}
    >
      <h6>{data.question}</h6>
      {data.options.map((opt, iDx) => (
        <div
          style={Object.assign(
            {},
            classes.opt,
            classes.pointer,
            value === opt.id ? classes.selectedOpt : {}
          )}
          key={opt.id}
        >
          <label className="d-flex" style={classes.pointer}>
            <input
              name={data.id}
              type="radio"
              onChange={() => {
                form.setFieldValue(data.id, opt.id);
                setAllRequired(false);
              }}
              style={{ transform: "scale(1.2)" }}
            />
            <div style={classes.ansText}>{opt.option}</div>
          </label>
        </div>
      ))}
    </div>
  );
};
